import React, { useLayoutEffect } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import Formatter from "../../../../services/utils/Formatter";

am4core.useTheme(am4themes_animated);

interface BarsProps {
  id: string;
  data: object[];
  targets: object[];
}

const Bars: React.FC<BarsProps> = ({ id, data, targets }) => {
  // const chart = useRef(null);

  useLayoutEffect(() => {
    let x = am4core.create(id, am4charts.XYChart);
    x.hiddenState.properties.opacity = 0;
    x.background.visible = false;
    x.language.locale["_decimalSeparator"] = ",";
    x.language.locale["_thousandSeparator"] = "."; 
    // Add data
    x.data = data;

    // Create axes
    var categoryAxis = x.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "category";
    categoryAxis.renderer.labels.template.fill = am4core.color("#00162b");
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.grid.template.disabled = true;
    categoryAxis.renderer.line.strokeOpacity = 0.5;
    categoryAxis.renderer.line.stroke = am4core.color("#00162b");
    //Set grid width so labels won't go missing
    categoryAxis.renderer.minGridDistance = 30;

    var valueAxis = x.yAxes.push(new am4charts.ValueAxis());
    valueAxis.min = 0;
    valueAxis.renderer.grid.template.disabled = true;
    valueAxis.renderer.labels.template.disabled = true;

    // Create series
    var columnSeries = x.series.push(new am4charts.ColumnSeries());
    columnSeries.dataFields.valueY = "value";
    columnSeries.dataFields.categoryX = "category";
    columnSeries.columns.template.fill = am4core.color("#00162b");

    var columnTemplate = columnSeries.columns.template;
    columnTemplate.strokeOpacity = 0;

    // Create value axis range(Target lines)
    targets.forEach((obj: any) => {
      const range = valueAxis.axisRanges.create();
      range.value = obj.value; // Valor da linha de target
      range.grid.stroke = am4core.color(obj.color);
      range.grid.strokeWidth = 2;
      range.grid.strokeOpacity = 1;
      range.grid.above = true;
      range.label.inside = true;
      range.label.text = Formatter.FormatNumber(obj.value)[0];
      range.label.fill = range.grid.stroke;
      range.label.align = "right";
      range.label.verticalCenter = obj.position;
    });

    var label = columnTemplate.createChild(am4core.Label);
    label.fontSize = 10;
    label.text = "{value}";
    label.fill = am4core.color("#fff");
    label.align = "center";
    label.valign = "bottom";

    columnSeries.columns.template.tooltipText = "{value}";

    /*--------------------------------------------------------------------------------------*/
    //chart.current = x;

    return () => {
      x.dispose();
    };
  }, [data]);

  return <div className="chart chart--center" id={id}></div>;
};

export default Bars;
